import { useState } from 'react'

const LEVELS = [
   { key: 'elementary', label: 'Elementary' },
   { key: 'highschool', label: 'High School' },
   { key: 'seniorhigh', label: 'Senior High' },
   { key: 'college', label: 'College' },
]

function EduLevel({ levelKey, label, data, onChange }) {
   const [open, setOpen] = useState(false)
   const hasData = data.school || data.yearStart || data.yearEnd

   function set(key, value) {
      onChange(levelKey, { ...data, [key]: value })
   }

   function addAchievement() {
      const last = data.achievements.at(-1)
      onChange(levelKey, {
         ...data,
         achievements: [...data.achievements, { id: last.id + 1, value: '' }],
      })
   }

   function setAchievement(e) {
      onChange(levelKey, {
         ...data,
         achievements: data.achievements.map(n =>
            n.id == e.target.id ? { ...n, value: e.target.value } : n,
         ),
      })
   }

   return (
      <div className={`edu-level${open ? ' edu-open' : ''}`}>
         <button className="edu-header" onClick={() => setOpen(p => !p)}>
            <span className="edu-label">{label}</span>
            {hasData && !open && (
               <span className="edu-hint">{data.school || '—'}</span>
            )}
            <svg
               className="edu-chevron"
               viewBox="0 0 16 16"
               fill="none"
               stroke="currentColor"
               strokeWidth="2"
               strokeLinecap="round">
               <path d="M4 6l4 4 4-4" />
            </svg>
         </button>

         {open && (
            <div className="edu-body">
               <div className="group edu-group">
                  <label>School / Institution</label>
                  <input
                     type="text"
                     placeholder={`${label} school name…`}
                     value={data.school}
                     onChange={e => set('school', e.target.value)}
                  />
               </div>

               <div className="edu-year-row">
                  <div className="group edu-group">
                     <label>From</label>
                     <input
                        type="text"
                        placeholder="2010"
                        value={data.yearStart}
                        onChange={e => set('yearStart', e.target.value)}
                     />
                  </div>
                  <span className="edu-dash">–</span>
                  <div className="group edu-group">
                     <label>To</label>
                     <input
                        type="text"
                        placeholder="2014"
                        value={data.yearEnd}
                        onChange={e => set('yearEnd', e.target.value)}
                     />
                  </div>
               </div>

               <div className="group-list edu-group">
                  <div className="group-list-header">
                     <label>Achievements</label>
                     <button className="btn-add" onClick={addAchievement}>
                        <svg
                           viewBox="0 0 16 16"
                           fill="none"
                           stroke="currentColor"
                           strokeWidth="2"
                           strokeLinecap="round">
                           <path d="M8 3v10M3 8h10" />
                        </svg>
                        <span>Add</span>
                     </button>
                  </div>
                  <div className="nodes">
                     {data.achievements.map((node, i) => (
                        <div key={node.id} className="node-row">
                           <span className="node-index">{i + 1}</span>
                           <input
                              id={node.id}
                              type="text"
                              placeholder="Award, honor, activity…"
                              value={node.value}
                              onChange={setAchievement}
                           />
                        </div>
                     ))}
                  </div>
               </div>
            </div>
         )}
      </div>
   )
}

function Education({ field, fieldHandler }) {
   function onChange(levelKey, updatedData) {
      fieldHandler(prev => ({
         ...prev,
         education: { ...prev.education, [levelKey]: updatedData },
      }))
   }

   return (
      <div className="group-list">
         <div className="group-list-header">
            <label>Education</label>
         </div>
         <div className="edu-levels">
            {LEVELS.map(lvl => (
               <EduLevel
                  key={lvl.key}
                  levelKey={lvl.key}
                  label={lvl.label}
                  data={field.education[lvl.key]}
                  onChange={onChange}
               />
            ))}
         </div>
      </div>
   )
}

export default Education
